import Header from "./components/Header";
 
import Homenew from "./pages/Homenew";
import Footer from "./components/Footer";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Service from "./pages/Service";
import Industry from "./pages/Industry";
import Client from "./pages/Client";
function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Homenew />} />
        <Route path="/service" element={<Service />} />
        <Route path="/industry" element={<Industry />} />
        <Route path="/clients" element={<Client />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
